import React from 'react'
import PropTypes from 'prop-types'
import { StyledInput, InputLabel, Input, InputText } from './Input.styled'

const InputCard = ({ label, onInputChange, defaultValue, helpContent }) => {
  return (
    <StyledInput>
      <InputLabel htmlFor={label}>{label}</InputLabel>
      <Input
        id={label}
        onChange={onInputChange}
        defaultValue={defaultValue}
        aria-label={`input area, please input yor ${label}`}
        autoFocus
      />
      {helpContent ? <InputText>{helpContent}</InputText> : null}
    </StyledInput>
  )
}
InputCard.propTypes = {
  label: PropTypes.string,
  onInputChange: PropTypes.func,
  defaultValue: PropTypes.string,
  helpContent: PropTypes.node,
}

export default InputCard
